import React, { useContext } from 'react'

import { ButtonV2 } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import filterContext from '@/components/pages/production/components/context'
import ticketDetailsContext from '@/components/pages/production/components/ticket-details/context'
import { trackEvent } from '@/utils/analytics/ga360'

import styles from './styles.module.scss'

interface Props {
    label: string
    quantity: number
}

const QuantityButton: React.FC<Props> = ({ label, quantity }) => {
    const {
        state: filterState,
        dispatch: { onQuantityFilterChangeAction: onFilterChange },
    } = useContext(filterContext)
    const {
        state: detailsState,
        dispatch: { toggleDetails },
    } = useContext(ticketDetailsContext)

    return (
        <ButtonV2
            importance="tertiary"
            size="large"
            data-testid={'quantity-' + quantity + '-button'}
            className={classNames(styles.quantityButton, {
                [styles.quantityButtonSelected]: filterState.quantityFilterState.quantity === quantity,
            })}
            onClick={() => {
                if (detailsState.listing) {
                    toggleDetails({ listing: null })
                }
                const newQuantity = filterState.quantityFilterState.quantity === quantity ? 0 : quantity
                onFilterChange({ quantity: newQuantity })
                trackEvent('FilterUse', 'UsedTicketFilters', 'Quantity', undefined, false)
                trackEvent('TicketFilterUse', 'Quantity-FilterModal', `${newQuantity}`, newQuantity, false)
            }}
        >
            <div className={quantity > 7 ? styles.quantity8 : styles.quantity1}>{label}</div>
        </ButtonV2>
    )
}

export default QuantityButton
